export default __webpack_public_path__ + "static/why-tecalis-2e49bcaa23b03905e2b5ceddd9ae3544.mp4";